export default {"src":"/_next/static/media/crossed_circle_grey.e54baed9.svg","height":19,"width":19};